(() => {
    const scrollTopBtn = document.getElementById("scrollTopBtn");

    function toggleScrollBtn() {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const docHeight = document.documentElement.scrollHeight - window.innerHeight;

        const scrolledPercent = (scrollTop / docHeight) * 100;

        scrollTopBtn.style.display = scrolledPercent >= 40 ? "flex" : "none";
    }

    window.addEventListener("scroll", toggleScrollBtn);

    scrollTopBtn.addEventListener("click", () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    });

})();